import { FC } from 'react'
import { DetailField, DetailFields, DetailPanel } from '../../../../../../components'
import { FaturaList } from '../../../faturas-list/core/_models'
import { useT } from '_metronic/i18n/Metronici18n'

type IProps = {
  data?: FaturaList
  isLoading?: boolean
}

export const FaturaResponsavelExpandedRow: FC<IProps> = ({ data, isLoading }) => {
  const { t } = useT()

  return (
    <DetailPanel isLoading={isLoading} loadingLabel='Carregando detalhes da fatura…'>
      {data && (
        <DetailFields>
          <DetailField
            label={t('observacao.label')}
            value={data.observacao}
            emptyLabel={t('common.none', { name: t('observacao.label.lowercase') })}
            wide
          />
        </DetailFields>
      )}
    </DetailPanel>
  )
}
